import React, { Component } from 'react';
import { Well, Jumbotron, Navbar, Nav, NavItem, Row, Col, Panel, Button } from 'react-bootstrap';

import { Router, Switch, Route, Link, } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import $ from 'jquery';
import './App.css';

import Header from './Header';
import Test from './Test';
import Report from './Report';
import Bottom from './Bottom';
import Irregular from './Irregular';
import IrregularTest from './Irregular_Test';
import OnlinePlay from './Online_Play';
import Part from './Part';
import Records from './Records';
import Rank from './Rank';

import wechat_shoukuan from './fanzhh_wechat_shoukuan.jpg';
import zhifubao_shoukuan from './fanzhh_zhifubao_shoukuan.png';
import math from './math.png';

const history = createHistory();

/*URL = 'http://idanciback.devlabs.cc/'; */
/*URL = 'http://localhost:8000/'; */
URL = 'https://idanciback.devlabs.cc/';

class App extends Component {
  /* 主部件 */
    constructor(props) {
      super(props);
      this.state = {
        username: '', /* 用户名、邮箱和密码 */
        password: '',
        email: '',
        token: '',
        isLogin: false,
        showLoginModal: false, /* 是否显示登录框 */
        showRegisterModal: false, /* 是否显示注册框 */
      };
      this.onLogin = this.onLogin.bind(this);
      this.onLogout = this.onLogout.bind(this);
      //this.showRegisterModal = this.showRegisterModal.bind(this);
      this.onRegister = this.onRegister.bind(this);
      this.onLogFormInputChange = this.onLogFormInputChange.bind(this);
    }
    /* 登录 */
    onLogin(event) {
      var that = this;
      const url = URL+'api-token-auth/';
      $(function(){$.ajax({
        data:{
          username:that.state.username,
          password:that.state.password
        },
        url: url,
        type: "POST",
        success: function(result){
          that.setState({token:result.token,isLogin:true,});
        },
        error: function(xhr, status, err){
          console.log(err);
          alert("登录时出现错误，出错信息："+ status + ", " + err);
        }
      })})
      this.setState({showLoginModal:false,})
    }

    onLogout(event) {
      this.setState({token:'',isLogin:false,username:'',password:'',});
    }

    showRegisterModal(){
	    this.setState({showRegisterModal:true,});
    }

    // 注册
    onRegister(event) {
      var that = this;
      const url = URL+'api/users/register/';
      $(function(){$.ajax({
        url: url,
        type: "POST",
        dataType: 'json',
        data:{
          username:that.state.username,
          password:that.state.password,
          email: that.state.email,
        },
        success: function(result){
          /*that.setState({token:result.token,isLogin:true,});*/
	        alert("您已注册成功，请登录。");
        },
        error: function(xhr, status, error){
          console.log(status,error.toString());
	  alert("注册出现错误，出错信息："+status+error);
        }
      })});
      this.setState({showRegisterModal:false,})
      this.setState({showLoginModal:true,})
    }

    onLogFormInputChange(event) {
      const id = event.target.id;
      this.setState({[id]:event.target.value.trim(),})
    }

    // <NavItem componentClass={Link} href="/play" to="/play">在线音频</NavItem>

    render() {
      return (
        <Router history={history}>
        <div className="App container">
          <Jumbotron>
          <Header
            isLogin={this.state.isLogin}
            username={this.state.username}
            onLogin={this.onLogin}
            onLogout={this.onLogout}
            onRegister={this.onRegister}
            onLogFormInputChange={this.onLogFormInputChange}
          />
          </Jumbotron>
          <Navbar>
          <Nav>
            <NavItem componentClass={Link} href="/" to="/">单词测试</NavItem>
            <NavItem componentClass={Link} href="/report" to="/report">我的错词</NavItem>
	          <NavItem componentClass={Link} href="/records" to="/records">测试记录</NavItem>
	          <NavItem componentClass={Link} href="/irregular" to="/irregular">不规则动词</NavItem>
	          <NavItem componentClass={Link} href="/part" to="/part">词性速查</NavItem>
            
          </Nav>
        </Navbar>
        <Row>
          <Col xs={12} sm={9} md={9}>
            <Switch>
	            <Route path="/" exact render={props=>
	              <Test isLogin={this.state.isLogin} token={this.state.token}/>
	            }/>
	            <Route path="/report" exact render={props=>
	              <Report token={this.state.token} isLogin={this.state.isLogin}/>
	            }/>
	            <Route path="/records" exact render={props=>
	              <Records token={this.state.token} isLogin={this.state.isLogin}/>
	            }/>
	            <Route path="/irregular" exact render={props=><Irregular />}/>
	            <Route path="/irregular_test" exact render={props=><IrregularTest />}/>
	            <Route path="/play" exact render={props=><OnlinePlay />}/>
	            <Route path="/part" exact render={props=><Part />}/>
	          </Switch>
          </Col>
          <Col xs={12} sm={3} md={3}>
            <Panel>
              <Panel.Heading>
                本月单词测试排名
              </Panel.Heading>
              <Panel.Body>
                <Rank year={(new Date()).getFullYear()} month={(new Date()).getMonth()+1} />
              </Panel.Body>
            </Panel>
            <Panel>
              <Panel.Heading>
                本年单词测试排名
              </Panel.Heading>
              <Panel.Body>
                <Rank year={(new Date()).getFullYear()} month="" />
              </Panel.Body>
            </Panel>
            {/*<Panel>
						  <Panel.Heading>
							  本站内容免费，如对您有帮助，欢迎打赏鼓励作者
						  </Panel.Heading>
						  <Panel.Body>
							  <Row>
								  <Col xs={6} sm={6} md={6}>
									  微信
									  <img src={wechat_shoukuan} alt="我的微信收款二维码" width="90" />
								  </Col>
								  <Col xs={6} sm={6} md={6}>
									  支付宝
									  <img src={zhifubao_shoukuan} alt="我的支付宝收款二维码" width="90" />
								  </Col>
							  </Row>
						  </Panel.Body>
					  </Panel>
            <Panel>
						  <Panel.Heading>友情链接</Panel.Heading>
						  <Panel.Body>
							  <Nav bsStyle="pills" stacked>
								  <NavItem href="https://www.funnymath.top">高一数学与信息技术</NavItem>
								  {/*<NavItem href="https://www.icuoti.top">基于知识点的网上错题管理系统</NavItem>
								  {/*<NavItem href="https://www.jianshu.com/u/a1094257c6d0">我的简书专栏</NavItem>
							  </Nav>
						  </Panel.Body>
					  </Panel>*/}
            <Panel>
						  <Panel.Heading>友情链接</Panel.Heading>
						  <Panel.Body>
            <div className="card">
              <a href="https://hsmath.fanzhh.pw" target="_blank"><img className="card-img-top" src={math} alt="高一数学与信息技术" width="100%" /></a>
              <div className="card-body">
                <h4 className="card-title">在信息技术中学习高一数学</h4>
                <p className="card-text">
                  使用信息技术理解高一数学知识，包含一次函数、二次函数、指数函数、对数函数、幂函数及自定义函数图形动态生成，二分法求函数零值算法演示等。
                </p>
                <a href="https://hsmath.fanzhh.pw" className="btn bth-primary" target="_blank">访问</a>
              </div>
            </div>
            </Panel.Body>
            </Panel>
          </Col>
        </Row>
        <Bottom/>
      </div>
      </Router>
      )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js